import React from "react";
import { FaFacebook, FaInstagram, FaTiktok } from "react-icons/fa";
import "../Assets/css/footer.css";

function Footer(){
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Contact Info */}
        <div className="footer-section">
          <h2 className="footer-title">Réseaux Québec Communication</h2>
          <p>contact@rqcagence.ca</p>
          {/* <p>+1 (123) 456-7890</p> */}
        </div>

        {/* Useful Links */}
        <div className="footer-section">
          <h3 className="footer-subtitle">Liens importants</h3>
          <ul>
            <li><a href="/">Acceuil</a></li>
            {/* <li><a href="/privacy">Services</a></li> */}
            <li><a href="/Contact">Contact</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          {/* <h3 className="footer-subtitle">Follow Us</h3> */}
          <div className="social-icons">
            {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FaFacebook />
            </a> */}
            {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a> */}
            <a href="https://www.instagram.com/agence_rqc/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
            <a href="https://www.tiktok.com/@rqc.agence/" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <FaTiktok />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Réseaux Québec Communication. Tous droits réservés.
      </div>
    </footer>
  );
};

export default Footer;
